import React, { useEffect, useState } from "react";
import DataTable from "../../../../components/common/DataTable";
import { useListStockBalancesQuery } from "../../stockApi";
import { useBranchFilter } from "../../../branchFilter/useBranchFilter";

// Read-only - deliberately no QR/barcode action here. The API generates a
// barcode per received Stock-In line/batch, not per product balance (that's
// what the handheld scanning device work will actually read later), so
// barcode printing lives on Stock-In detail instead of here.
const StockBalancesPage = () => {
  const { selectedBranchId } = useBranchFilter();
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const handle = setTimeout(() => setSearch(searchInput.trim()), 400);
    return () => clearTimeout(handle);
  }, [searchInput]);

  const { data, isLoading } = useListStockBalancesQuery({
    branchId: selectedBranchId ?? undefined,
    search: search || undefined,
    pageSize: 200,
  });

  const columns = [
    { title: "Product", dataIndex: "productName", render: (v, r) => `${v} (${r.productCode})` },
    { title: "Group", dataIndex: "productGroupName", render: (v) => v || "-" },
    { title: "Branch", dataIndex: "branchCode" },
    { title: "Current Qty", dataIndex: "currentQty", render: (v) => Number(v || 0).toFixed(2) },
    { title: "Last Movement", dataIndex: "lastMovementType", render: (v) => v?.replaceAll("_", " ") || "-" },
    { title: "Last Movement Date", dataIndex: "lastMovementDate", render: (v) => (v ? new Date(v).toLocaleString() : "-") },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Stock Balances</h4>
              <h6>Current stock on hand per product</h6>
            </div>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top flex-wrap gap-2">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search product name or code"
                    className="form-control form-control-sm formsearch"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <DataTable columns={columns} dataSource={data?.items || []} rowKey="balanceId" loading={isLoading} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockBalancesPage;
